import RoleHome from '../RoleHome';

export default function RadiologistPage() {
  return (
    <RoleHome
      title="Radiologist"
      description="Sonar requests and imaging results."
    />
  );
}
